import React, {
	useState,
	useEffect
} from 'react';
import PropTypes from 'prop-types';

import {
	makeStyles,
	Table,
	TableBody,
	TableRow,
	TableCell,
	Typography,
	Collapse,
	Button,
} from '@material-ui/core';

import Timestamp from "./Timestamp";
import Constants from "../utils/Constants";

const styles = makeStyles(theme => ({
	row: {
		height: "auto",

		"& td": {
			borderBottom: "none",
			verticalAlign: "top",
			paddingLeft: theme.spacing(.5),

			"&:last-child": {
				width: "88%"
			},

			"& p": {
				fontSize: "0.93rem",
				//color: theme.palette.text.secondary
			}
		}
	},

	button: {
		//marginTop: theme.spacing(1.5),
		marginLeft: theme.spacing(1) / -2
	},

	table: {
		"& td, & td:last-child": {
			paddingBottom: theme.spacing(1)
		}
	}
}));

function ExtraHeaderInfo(props) {
	const [collapsed, setCollapsed] = useState(true);

	const toggleDetails = () => {
		setCollapsed(!collapsed);
	};

	let classes = styles(),
		{headers, className, expanded, excludeSent} = props,
		splitAddresses = (addresses) => {
			if (addresses) {
				return addresses.replace(/,/ig, '\n').split('\n').map((item, key, array) => {
					let name,
						address,
						match = item.match(Constants.ACTIVITY.EMAIL.FROM_REGEX);

					// 0 is the full string, 1 is name, 2 is email
					if (match) {
						address = match[2];
						name = match[1].trim();
					}

					return <span key={key}><b>{match ? name : null}</b>{match ? " " + address : item}{key < array.length-1 ? "," : null}<br/></span>;
				});
			}
		};

	useEffect(() => {
		if (expanded === true) {
			setCollapsed(false);
		}
	}, [expanded, setCollapsed]);

	return (
		<div className={className}>
			{headers.to ?
				<Table padding="none" className={classes.table}>
					<TableBody>
						<TableRow className={classes.row}>
							<TableCell>
								<Typography>To:</Typography>
							</TableCell>
							<TableCell>
								<Typography>{splitAddresses(headers.to)}</Typography>
							</TableCell>
						</TableRow>
					</TableBody>
				</Table> : null
			}
			<Collapse in={!collapsed}>
				<Table padding="none" className={classes.table}>
					<TableBody>
						{headers.cc ?
							<TableRow className={classes.row}>
								<TableCell>
									<Typography>Cc:</Typography>
								</TableCell>
								<TableCell>
									<Typography>{splitAddresses(headers.cc)}</Typography>
								</TableCell>
							</TableRow> : null
						}
						{headers.bcc ?
							<TableRow className={classes.row}>
								<TableCell>
									<Typography>Bcc:</Typography>
								</TableCell>
								<TableCell>
									<Typography>{splitAddresses(headers.bcc)}</Typography>
								</TableCell>
							</TableRow> : null
						}
						{!excludeSent && (headers.to || headers.cc || headers.bcc) ?
							<TableRow className={classes.row}>
								<TableCell>
									<Typography>Sent:</Typography>
								</TableCell>
								<TableCell>
									<Timestamp time={headers.sent} relative={false} reducedSize={false} palette="primary" />
								</TableCell>
							</TableRow> : null
						}
					</TableBody>
				</Table>
			</Collapse>
			{!expanded && (headers.to || headers.cc || headers.bcc) ?
				<Button size="small" color="primary" className={classes.button} onClick={toggleDetails}>
					{collapsed ? "show details" : "hide details"}
				</Button> : null
			}
		</div>
	);
}

ExtraHeaderInfo.propTypes = {
	headers: PropTypes.object.isRequired,
	className: PropTypes.string,
	expanded: PropTypes.bool,
	excludeSent: PropTypes.bool
};

export default ExtraHeaderInfo;
